module.exports = __webpack_public_path__ + "resources/img/main04_jp_m.a3f38f60067b6f0b9895dd2b2353a835.png";